import React from "react"
import './logo.css'
import logo from '../assets/logo.png'

const Header = () => {

  return (
    <div className='logo-container'>
      <img className='logo' src={logo} alt=""></img>
      <div className='desc'>
        <div className='brand'>海南时运之驾互动娱乐</div>
      </div>
    </div>
  );
};

export default Header;